/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RemoteJobStatusFromJSON, RemoteJobStatusToJSON } from './';
export function RemoteJobRepresentationFromJSON(json) {
    return RemoteJobRepresentationFromJSONTyped(json, false);
}
export function RemoteJobRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        description: !exists(json, 'description') ? undefined : json['description'],
        expectedArguments: json['expectedArguments'],
        schedule: !exists(json, 'schedule') ? undefined : json['schedule'],
        status: RemoteJobStatusFromJSON(json['status']),
    };
}
export function RemoteJobRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        description: value.description,
        expectedArguments: value.expectedArguments,
        schedule: value.schedule,
        status: RemoteJobStatusToJSON(value.status),
    };
}
